import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, FormGroup, Button, Label, InputGroup, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Flatpickr from 'react-flatpickr';
import 'react-drawer/lib/react-drawer.css';
import 'flatpickr/dist/themes/material_blue.css';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import NumberFormat from 'react-number-format';
import ReactApexChart from 'react-apexcharts';
import { editProfile } from '../../store/profile/actions';
import { allowedDepartments } from '../../helpers/currency_helper';

class WelcomeComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu_toggle: false,
      isEditPlanVisible: false,
      medAndAvg: false,
      planAmount: null
    };
    this.toggleDashMenu = this.toggleDashMenu.bind(this);
    this.toggleMedAndAvgModal = this.toggleMedAndAvgModal.bind(this);
    this.getPlanGraph = this.getPlanGraph.bind(this);

    this.handleFilterDataSubmit = this.handleFilterDataSubmit.bind(this);
    this.resetFilterData = this.resetFilterData.bind(this);
    this.handlePlanAmountSubmit = this.handlePlanAmountSubmit.bind(this);
    this.handleFormulaCalc = this.handleFormulaCalc.bind(this);
  }
  toggleDashMenu = () => this.setState((prevState) => ({ menu_toggle: !prevState.menu_toggle }));
  toggleMedAndAvgModal = () => this.setState((prevState) => ({ medAndAvg: !prevState.medAndAvg, showData: false }));
  /**
   * Display loading comparison between current and planned amount
   * @param {*} totalSaleAmount
   * @returns
   */
  getPlanGraph = (totalSaleAmount) => {
    const { profileData } = this.props.props;
    const PlanCovered = profileData.planAmount !== 0 && parseFloat(((totalSaleAmount / profileData.planAmount) * 100).toFixed(2));
    const Plan = {
      chart: {
        height: 200,
        type: 'radialBar',
        offsetY: -10
      },
      options: {
        plotOptions: {
          radialBar: {
            startAngle: -125,
            endAngle: 130,
            dataLabels: {
              name: {
                fontSize: '13px',
                color: void 0,
                offsetY: 60
              },
              value: {
                offsetY: 22,
                fontSize: '16px',
                color: void 0,
                formatter: function (e) {
                  return e + '%';
                }
              }
            }
          }
        },
        colors: ['#556ee6'],
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            shadeIntensity: 0.15,
            inverseColors: !1,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91]
          }
        },
        stroke: {
          dashArray: 4
        },
        labels: ['']
      },
      series: [PlanCovered]
    };
    return Plan;
  };
  /**
   * Function to filter data from selected year/month/manager
   * @param {*} e
   * @param {array} values
   * @returns filtered data
   */
  handleFilterDataSubmit = (e, values) => {
    const { onGetDashboardInfoFilter, profileData } = this.props.props;
    const data = {
      year: values['year'],
      periodNo: !isNaN(values['periodNo']) ? parseInt(values['periodNo']) : values['periodNo'],
      request: true,
      id: profileData._id
    };
    onGetDashboardInfoFilter(data);
  };
  resetFilterData = (e) => {
    e.preventDefault();
    window.location.reload();
  };
  /**
   * Update Plan Amount
   * @param {*} e
   * @param {*} values
   */
  handlePlanAmountSubmit = (e, values) => {
    const { onEditProfile } = this.props;
    const { profileData } = this.props.props;

    const updateEmployee = {
      _id: profileData._id,
      workEmail: profileData.workEmail,
      planAmount: values['plan']
    };
    this.setState({
      planAmount: values['plan']
    });
    // update employee information
    onEditProfile(updateEmployee);
    this.setState({ isEditPlanVisible: false });
  };
  /**
   * Calculate median and average
   * @param {*} calc
   */
  handleFormulaCalc = (calc) => {
    const { onGetMedianAndAverage, profileData } = this.props.props;
    let dates = [];
    calc.map((date, key) => {
      dates.push(new Date(date).toLocaleDateString('en-GB').split('/').reverse().join('-'));
      return dates;
    });

    dates.push(profileData._id);
    onGetMedianAndAverage(dates);
    this.setState({ showData: true });
  };
  render() {
    const { profileData, curInfo, date, periodFrames } = this.props.props;
    const { menu_toggle, isEditPlanVisible, planAmount, medAndAvg } = this.state;
    return (
      <React.Fragment>
        <Col lg='12'>
          <Card className='dashboard-card'>
            <CardBody className='pt-0 pb-0'>
              <Row>
                <Col lg='3' className='align-self-center'>
                  <div className='d-flex'>
                    <div className='me-3'>
                      {profileData.profilePic === '' ? (
                        <div className='avatar-lg profile-user-wid '>
                          <span className='font-size-20 avatar-title rounded-circle'>{profileData.fname.charAt(0)}</span>
                        </div>
                      ) : (
                        <img src={profileData.profilePic} alt='' className='avatar-lg rounded-circle img-thumbnail' />
                      )}
                    </div>
                    <div className='flex-1 align-self-center'>
                      <div className='text-muted'>
                        <p className='mb-2'>Welcome to Koru Pharma</p>
                        <h4 className='mb-1 make-text-bold'>
                          {profileData.fname} {profileData.sname}
                        </h4>
                        <p className='mb-0 font-size-14'>{profileData.position}</p>
                      </div>
                    </div>
                  </div>
                </Col>
                {allowedDepartments.includes(profileData.department.depName) && (
                  <>
                    <Col md='3' sm='12' className='ps-0 align-self-center'>
                      <div className='clearfix mt-4 mt-lg-0'>
                        <AvForm className='d-flex ' id='filter-date-form' onValidSubmit={this.handleFilterDataSubmit}>
                          <FormGroup className='me-1'>
                            <AvField type='select' name='year' id='year' className='form-select' onChange={this.handleFilterChange} value={date.length !== 0 && date[0].year}>
                              <option className='fw-bold fs-5' value='2021'>
                                2021
                              </option>
                              <option className='fw-bold fs-5' value='2022'>
                                2022
                              </option>
                              <option className='fw-bold fs-5' value='2023'>
                                2023
                              </option>
                              <option className='fw-bold fs-5' value='2024'>
                                2024
                              </option>
                              <option className='fw-bold fs-5' value='2025'>
                                2025
                              </option>
                              <option className='fw-bold fs-5' value='2026'>
                                2026
                              </option>
                            </AvField>
                          </FormGroup>
                          <FormGroup className='me-1'>
                            <AvField type='select' name='periodNo' className='form-select' onChange={this.handleFilterChange} value={date.length !== 0 && date[0].periodNo}>
                              <optgroup label="By Year">
                                <option className='fw-bold fs-5' value='0'> Whole Year </option>
                              </optgroup>
                              <optgroup label="By Quarter">
                                <option className='fw-bold fs-5' value='1'>
                                  January - March
                                </option>
                                <option className='fw-bold fs-5' value='2'>
                                  April - June
                                </option>
                                <option className='fw-bold fs-5' value='3'>
                                  July - September
                                </option>
                                <option className='fw-bold fs-5' value='4'>
                                  October - December
                                </option>
                                {/* {periodFrames.map((period) => {
                                  return (
                                    <option key={period.periodNo} value={parseInt(period.periodNo)}>
                                      {period.monthSt} - {period.monthEnd}
                                    </option>
                                  );
                                })} */}
                              </optgroup>
                              <optgroup label="By Month">
                                <option value='January'>January</option>
                                <option value='February'>February</option>
                                <option value='March'>March</option>
                                <option value='April'>April</option>
                                <option value='May'>May</option>
                                <option value='June'>June</option>
                                <option value='July'>July</option>
                                <option value='August'>August</option>
                                <option value='September'>September</option>
                                <option value='October'>October</option>
                                <option value='November'>November</option>
                                <option value='December'>December</option>
                              </optgroup>
                            </AvField>
                          </FormGroup>
                          <FormGroup className='me-1'>
                            <button className='btn btn-success save-user' id='dblclick'>
                              Filter
                            </button>
                          </FormGroup>
                          <FormGroup className=''>
                            <button type='reset' onClick={this.resetFilterData} className='btn btn-primary save-user'>
                              Resets
                            </button>
                          </FormGroup>
                        </AvForm>
                      </div>
                    </Col>
                    <Col lg='3' className='align-self-center d-flex'>
                      <div className='flex-1 align-self-center'>
                        <div className='text-muted'>
                          <p className='mb-2'>Period Plan</p>
                          <h4 className='mb-1 make-text-bold'>
                            <NumberFormat value={curInfo.length !== 0 && curInfo.totalSaleAmount.toFixed(2)} displayType='text' thousandSeparator={true} prefix='$' />/
                            {isEditPlanVisible ? (
                              <Col md={10} className='d-flex'>
                                <AvForm id='my-form' onValidSubmit={this.handlePlanAmountSubmit}>
                                  <FormGroup className='ms-2 mb-2'>
                                    <AvField
                                      name='plan'
                                      type='number'
                                      errorMessage='Invalid number'
                                      validate={{
                                        required: { value: true }
                                      }}
                                      value={profileData.planAmount}
                                    />
                                  </FormGroup>
                                </AvForm>
                                <Button form='my-form' type='submit' className='ms-1 plan-button-style p-0' color='success'>
                                  <i className='bx bx-comment-check font-size-22 align-middle'></i>
                                </Button>
                                <Button color='danger' className='ms-1 p-0 plan-button-style' onClick={() => this.setState({ isEditPlanVisible: false })}>
                                  <i className='bx bx-x font-size-24 align-middle'></i>
                                </Button>
                              </Col>
                            ) : (
                              <NumberFormat value={planAmount != null ? planAmount : profileData.planAmount} displayType='text' thousandSeparator={true} prefix='$' />
                            )}
                          </h4>
                        </div>
                      </div>
                      <div className=' mt-sm-0'>
                        <ReactApexChart
                          options={this.getPlanGraph(curInfo.totalSaleAmount).options}
                          series={this.getPlanGraph(curInfo.totalSaleAmount).series}
                          type='radialBar'
                          height='150'
                          className='apex-charts'
                        />
                      </div>
                    </Col>
                    <Col lg='3' className='align-self-center'>
                      <div className='clearfix mt-4 mt-lg-0'>
                        <Dropdown isOpen={menu_toggle} toggle={this.toggleDashMenu} className='float-end'>
                          <DropdownToggle tag='button' className='btn btn-primary'>
                            <i className='mdi mdi-calculator-variant-outline me-1 font-size-22'></i> Actions
                          </DropdownToggle>
                          <DropdownMenu className='dropdown-menu-end'>
                            <DropdownItem onClick={() => this.setState({ isEditPlanVisible: true })}>Set Two Month Plan</DropdownItem>
                            <DropdownItem onClick={this.toggleMedAndAvgModal}>Median & Average</DropdownItem>
                            {/* <DropdownItem href="#">Something else</DropdownItem> */}
                          </DropdownMenu>
                        </Dropdown>
                        <Modal size='md' isOpen={medAndAvg} className={this.props.className} toggle={this.toggleMedAndAvgModal}>
                          <ModalHeader toggle={this.toggleMedAndAvgModal} tag='h4'>
                            Median and Average
                          </ModalHeader>
                          <ModalBody>
                            <FormGroup className='mb-4'>
                              <Label>Date Range</Label>
                              <InputGroup>
                                <Flatpickr
                                  className='form-control d-block'
                                  placeholder='dd M,yyyy'
                                  options={{
                                    mode: 'range',
                                    dateFormat: 'Y-m-d'
                                  }}
                                  onClose={this.handleFormulaCalc}
                                />
                              </InputGroup>
                            </FormGroup>
                            {this.state.showData && (
                              <>
                                <h3>
                                  Your Median for selected period is :{' '}
                                  <b>
                                    <NumberFormat value={this.props.props.median.toFixed(2)} displayType='text' thousandSeparator={true} prefix='$' />
                                  </b>{' '}
                                </h3>

                                <h3>
                                  Your Average for selected period is :{' '}
                                  <b>
                                    <NumberFormat value={this.props.props.avg.toFixed(2)} displayType='text' thousandSeparator={true} prefix='$' />
                                  </b>
                                </h3>
                              </>
                            )}
                          </ModalBody>
                        </Modal>
                      </div>
                    </Col>
                  </>
                )}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    );
  }
}

WelcomeComp.propTypes = {
  onEditProfile: PropTypes.func
};
const mapStateToProps = (state) => {
  const { error, success, loading } = state.Profile;
  return { error, success, loading };
};
const mapDispatchToProps = (dispatch) => ({
  onEditProfile: (employee) => dispatch(editProfile(employee))
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WelcomeComp));
